import React from 'react'
import { Box, Alert, AlertIcon } from '@chakra-ui/react'
import { useAuth } from '@/contexts/AuthContext'

function ForbiddenView() {
  return (
    <Box p={{ base: 4, md: 6 }}>
      <Alert status="error">
        <AlertIcon />
        Access denied. Super admin privileges required.
      </Alert>
    </Box>
  )
}

export function useAdminGuard() {
  const { user } = useAuth()
  const isAuthorized = user?.role === 'super'

  return {
    isAuthorized,
    ForbiddenView: isAuthorized ? null : <ForbiddenView />,
  }
}
